let gallery = jQuery('#post-gallery .slide a');
jQuery('#post-gallery .slide a').on('click', function(e) {
	e.preventDefault();
let totalSlides = + jQuery(this).parents('#post-gallery.slider').slick("getSlick").slideCount,
dataIndex = + jQuery(this).parents('#post-gallery .slide').data('slick-index'),
trueIndex;
switch(true){
	case (dataIndex<0):
	trueIndex = totalSlides+dataIndex; break;
	case (dataIndex>=totalSlides):
	trueIndex = dataIndex%totalSlides; break;
	default: 
	trueIndex = dataIndex;
}  

jQuery.fancybox.open(gallery,{}, trueIndex);
	return false;
});



jQuery('#post-gallery.slider').slick({
	slidesToShow: 3,
	arrows: true,
	dots: false,
	autoplay: false,
	pauseOnHover: false,
	pauseOnFocus: false,
	cssEase: 'linear',
	prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
	customPaging: function() {
		return ''
	},
	responsive: [
	{
		breakpoint: 900,
		settings: {
			slidesToShow: 2,
		}
	},
	{
		breakpoint: 500,
		settings: {
			slidesToShow: 1
		}
	}
	]
});


function resizedw(){
	jQuery('#post-gallery.slider').slick('unslick');
	jQuery('#post-gallery.slider').slick({
		slidesToShow: 3,
		arrows: true,
		dots: true,
		speed: 5000,
		autoplay: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		cssEase: 'linear', 
		autoplaySpeed: 0,
		customPaging: function() {
			return ''
		},
		responsive: [
		{
			breakpoint: 900,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 1
			}
		}
		]
	});
}

let doit;
window.onresize = function(){
	clearTimeout(doit);
	doit = setTimeout(resizedw, 1000);
};